import React, { useState, useEffect } from "react";
import { fetchHtml } from "../../lib/Fetching";
import Link from "../Link";

export default function MediaReport({ trayIds }) {
  const [html, setHtml] = useState("");

  useEffect(
    () => {
      fetchHtml("/sample_reception/media_report/show", { tray_ids: trayIds }).then((html) =>
        setHtml(html)
      );
    },
    [trayIds]
  );

  if (!html) return <div>Loading...</div>;

  return (
    <div className="basic-panel with-padding">
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
}
